import type { ReactNode } from 'react';
import type { Tone } from '../state/periods';

/** A status pill in one of the app's semantic tones. */
export function TonePill({ tone, title, children }: { tone: Tone; title?: string; children: ReactNode }) {
  if (tone === 'neutral') {
    return (
      <span className="pill" title={title} style={{ background: 'var(--rule)', color: 'var(--label)' }}>
        {children}
      </span>
    );
  }
  return <span className={`pill pill--${tone}`} title={title}>{children}</span>;
}
